import { useNavigate, useSearchParams } from 'react-router-dom';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import { ShieldCheck } from 'lucide-react';
import { RegenLogo } from '@/components/RegenLogo';

export default function ResetPassword() {
  const nav = useNavigate();
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error('Passwords do not match');
    if (pw.length < 6) return toast.error('Password must be at least 6 characters');
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, password: pw });
      toast.success('Password updated — please sign in');
      nav('/login');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Reset failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col justify-center px-6 max-w-md mx-auto">
      <RegenLogo size="md" />
      <h1 className="font-display font-black text-3xl mt-6 tracking-tight">Set a new password</h1>
      {!token ? (
        <p className="text-[#FF5C5C] text-sm mt-3" data-testid="reset-no-token">This reset link is invalid or incomplete. Please request a new one.</p>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <Label htmlFor="pw"><ShieldCheck className="w-3.5 h-3.5 inline mr-1" /> New Password</Label>
            <Input id="pw" type="password" data-testid="reset-password" value={pw} onChange={e => setPw(e.target.value)} required minLength={6} className="mt-1.5 bg-regen-card border-[var(--c-hair)] h-12" />
          </div>
          <div>
            <Label htmlFor="pw2">Confirm Password</Label>
            <Input id="pw2" type="password" data-testid="reset-password-confirm" value={pw2} onChange={e => setPw2(e.target.value)} required minLength={6} className="mt-1.5 bg-regen-card border-[var(--c-hair)] h-12" />
          </div>
          <Button type="submit" disabled={loading} data-testid="reset-submit" className="h-14 w-full bg-[#00C8FF] hover:bg-[#00C8FF]/90 text-[#081726] font-semibold rounded-2xl">
            {loading ? 'Updating…' : 'Update Password'}
          </Button>
        </form>
      )}
    </div>
  );
}
